import { ThemeUICSSObject } from '@apia/theme';

const spinner: ThemeUICSSObject = {
  position: 'fixed',
  left: '50%',
  top: '50%',
  transform: 'translate(-50%, -50%)',
  zIndex: '10000',
};

export default spinner;
